import React, {
  createContext,
  useState, useEffect
} from "react";
import useLocalStorage from "../utils/useLocalStorage";

export const NewProjectContext = createContext();

const NewProjectContextProvider = ({
  children
}) => {
  const [storage, setStorage] = useLocalStorage('storage',{
    need: "",
    pack: null,
    order: null
  });

  const [store, setStore] = useState(storage);
  const [need, setNeed] = useState(store.need);
  const [pack, setPack] = useState(store.pack);
  const [order, setOrder] = useState(store.order);

  const handleNeed = (need) => {
    if (need !== "") {
      setNeed(need);
      setStorage({...store, "need": need})
    }
  };

  const handlePack = (pack) => {
    if (pack !== null) {
      setPack(pack);
      setStorage({...store, "pack": pack})
    }
  };

  const handleOrder = (order) => {
    if (order !== null) {
      setOrder(order);
      setStorage({...store, "order": order})
    }
  };

  const updateStorage = (object) => {
    setStorage(object);
  }

  useEffect(() => {
    if(storage) {
      setStore(storage);
    }
  },[storage]);

  return ( <
    NewProjectContext.Provider value = {
      {
        need,
        pack,
        order,
        handleNeed,
        handlePack,
        handleOrder,
        updateStorage,
      }
    } >
    {
      children
    } </NewProjectContext.Provider>
  );
};


export default NewProjectContextProvider;